import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import Errors from './Errors';
var defaultUseEffectArrayFieldTransform = function defaultUseEffectArrayFieldTransform(item) {
  return item;
};
var MultiFieldValidation = function MultiFieldValidation(_ref) {
  var fields = _ref.fields,
    messages = _ref.messages,
    name = _ref.name,
    _ref$useEffectArrayFi = _ref.useEffectArrayFieldTransform,
    useEffectArrayFieldTransform = _ref$useEffectArrayFi === void 0 ? defaultUseEffectArrayFieldTransform : _ref$useEffectArrayFi,
    validators = _ref.validators,
    _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles;
  var validationKey = Object.keys(validators)[0];
  var validate = validators[validationKey];
  var message = messages[validationKey];
  if (!validate || !message) {
    return null;
  }
  var _useFormContext = useFormContext(),
    setError = _useFormContext.setError,
    clearErrors = _useFormContext.clearErrors,
    watch = _useFormContext.watch;
  var fieldsToWatch = watch(fields);
  useEffect(function () {
    if (validate(fieldsToWatch)) {
      clearErrors(name);
    } else {
      setError(name, {
        message: validationKey
      });
    }
  }, fieldsToWatch.map(function (field) {
    return useEffectArrayFieldTransform(field);
  }));
  useEffect(function () {
    return function () {
      return clearErrors(name);
    };
  }, []);
  return /*#__PURE__*/React.createElement(Errors, {
    name: name,
    styles: styles,
    messages: messages
  });
};
export default MultiFieldValidation;